<template>
  <LoginForm :has-recaptcha="isRecaptchaEnabled" />
</template>

<script>
  import LoginForm from '../../components/forms/auth/Login';

  export default {
    components: {
      LoginForm,
    },
    data() {
      return {
        recaptcha: import.meta.env.VUE_APP_USE_RECAPTCHA,
        recaptchaKey: import.meta.env.VUE_APP_RECAPTCHA_KEY,
      };
    },
    computed: {
      isRecaptchaEnabled() {
        const { recaptcha, recaptchaKey } = this;

        return recaptcha === 'true' && recaptchaKey !== '';
      },
    },
    metaInfo() {
      return {
        title: this.$t('views_login_title'),
      };
    },
  };
</script>
